import { render } from "./NotePopover.vue?vue&type=template&id=b5115ca6&scoped=true"
import script from "./NotePopover.vue?vue&type=script&lang=js"
export * from "./NotePopover.vue?vue&type=script&lang=js"

import "./NotePopover.vue?vue&type=style&index=0&id=b5115ca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5115ca6"]])

export default __exports__